<seb-titlebar [hideButtonTitlebar]="hideButtonTitlebar" [paths]='titleHeader' [labelButton]='labelTitleModal'>
</seb-titlebar>
<div class="container">
  <h5 class="dashTitle">{{indiceUD}}</h5>
  <div class="dashContent">
    <iframe class="dashPowerBi" [src]="urlPowerBi" frameborder="0"></iframe>
  </div>
</div>
